import { TextArea } from 'semantic-ui-react';
import { Link, useRouteError } from 'react-router-dom';
import { DisplayMessage } from './displayMessage';

const b64EncodeUnicode = (str) => btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(`0x${p1}`)));

export function RouterErrorElement() {
  const error = useRouteError();

  const message = (error && (error.message || error.statusText)) || 'Unknown error';
  const stack = (error && error.stack) || (typeof error === 'object' ? JSON.stringify(error, null, 2) : String(error));

  const errorObj = { message, stack, componentStack: '' };
  const errorInfo = process.env.NODE_ENV === 'production'
    ? b64EncodeUnicode(JSON.stringify(errorObj))
    : JSON.stringify(errorObj, null, 2);

  return (
    <DisplayMessage
      helmet=':('
      header={<span className='f1'>:(</span>}
      content={(
        <>
          An internal error in the application has occurred,
          <br />
          <br />
          Click
          {' '}
          <Link href='/'>here</Link>
          {' '}
          to return to the main page.
          <br />
          <br />
          If you want to help us, send us this message by email to (Altomobile@outlook.com):
          <br />
          <br />
          <TextArea
            className='w-100'
            value={errorInfo}
            rows={10}
            readOnly
          />
        </>
        )}
    />
  );
}
